import type { CoverableChangesDTO } from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/onlinesales/dto/quote';
import { selector } from 'recoil';
import { OnlineSalesUnauthenticated } from 'gw-edge-client';
import { isLoggedOnSelector } from './isLoggedOnSelector';
import { jobInfoAtom } from '../atoms/jobInfoAtom';
import { refreshCoverableChangesSelectorAtom } from '../atoms/refreshCoverableChangesSelectorAtom';

export const coverableChangesSelector = selector<CoverableChangesDTO[]>({
    key: 'coverableChangesSelector',
    get: async ({ get }) => {
        const { jobNumber, sessionId } = get(jobInfoAtom);
        const isLoggedOn = get(isLoggedOnSelector);
        get(refreshCoverableChangesSelectorAtom);

        if (!jobNumber || !sessionId) {
            throw new Error('Invalid quote- or session ID');
        }
        return await OnlineSalesUnauthenticated.getChanges(jobNumber, sessionId, !isLoggedOn);
    }
});
